// Content for Śrīmad-Bhāgavatam 11.5.41 commentary topic

import type { TopicContent } from '../types';

const content: TopicContent = {
    primarySloka: {
        reference: 'Srimad Bhagavatam 11.5.41',
        sloka: `devarṣi-bhūtāpta-nṛṇāṁ pitṛṇāṁ
na kiṅkaro nāyam ṛṇī ca rājan
sarvātmanā yaḥ śaraṇaṁ śaraṇyaṁ
gato mukundaṁ parihṛtya kartam ||`,
        translation:
            'O King (<strong>rājan</strong>)! One who has given up all varṇāśrama duties (<strong>parihṛtya kartam</strong>) and has taken full shelter of the lotus feet of Mukunda (<strong>sarvātmanā yaḥ śaraṇaṁ śaraṇyaṁ gato mukundaṁ</strong>), who offers shelter to all (<strong>śaraṇyaṁ</strong>), is not a debtor to or servant of (<strong>na kiṅkaro nāyam ṛṇī ca</strong>) the devatās, great sages, ordinary living beings, relatives or Pitṛs (<strong>devarṣi-bhūtāpta-nṛṇāṁ pitṛṇāṁ</strong>).',
    },
    blocks: [
        {
            type: 'text',
            content:
                'This verse shows that <strong>bhakti is devoid of the troubles caused by daily and occasional duties such as śrāddha rites and tarpaṇas.</strong> <em>Āpta</em> refers to those who give nourishment such as mother and father. <em>Devatās</em> refers to the devatās of the five sacrifices.<br /><br />One involved in karmas is the debtor and servant of the devatās, sages, living beings, parents, and Pitṛs. He daily performs the five sacrifices for them. Smṛti says <em>parikṣīṇam ṛṇārthaṁ karma kārayet</em>: one should perform karmas for destroying debts.<br /><br /><strong>That is not so for the devotee who has surrendered completely to Mukunda. It is just like a person who, on being accepted as the servant of the emperor of the earth, cannot be the servant of the ruler of a province.</strong>',
        },
        {
            type: 'text',
            content:
                'This person has given up all prescribed varṇāśrama duties (<em>kartam</em>) or has give up all distinctions. <strong>When one worships Viṣṇu all worship of devatās and Pitṛs is accomplished as is stated elsewhere:</strong>',
        },
        {
            type: 'sloka',
            sloka: {
                reference: 'Srimad Bhagavatam 4.31.14',
                sloka: `athā taror mūla-niṣecanena
tṛpyanti tat-skandha-bhujopaśākhāḥ
prāṇopahārāc ca yathendriyāṇāṁ
tathaiva sarvārhaṇam acyutejyā`,
                translation:
                    'By giving water to the root of a tree one satisfies its branches, twigs and leaves, and by supplying food to the stomach one satisfies all the senses of the body. Similarly, by engaging in the transcendental service of the Supreme Lord one automatically satisfies all the devatās and all other living entities.',
            },
        },
        {
            type: 'text',
            content: 'The Lord himself has said:',
        },
        {
            type: 'sloka',
            sloka: {
                reference: 'Srimad Bhagavatam 11.20.9',
                sloka: `tāvat karmāṇi kurvīta
na nirvidyeta yāvatā
mat-kathā-śravaṇādau vā
śraddhā yāvan na jāyate`,
                translation:
                    'One should continue to perform the Vedic ritualistic activities until one actually becomes detached from material sense gratification and develops faith for hearing and chanting about me.',
            },
        },
        {
            type: 'text',
            content: '<strong>Thus the devotee has far surpassed the qualification for karma.</strong>',
        },
    ],
};

export default content;
